<template>
  <section class="contact-block" :id="anchorId">
    <div class="container">
      <h2 v-if="data.content.section_title">{{ data.content.section_title }}</h2>

      <div class="contact-intro" v-if="data.content.intro">
        <Arrow />
        <span v-html="data.content.intro" />
      </div>

      <ContactForm
        :email-placeholder="data.content.email_placeholder"
        :subject-placeholder="data.content.subject_placeholder"
        :form-fields="data.content.form_fields"
        :submit-text="data.content.submit_text"
        :success-message="data.content.success_message"
      />
    </div>
  </section>

  <FloatingContactButton
    :text="data.content.helper_text"
    :anchor-id="anchorId"
  />
</template>

<script setup>
import ContactForm from './Contact/ContactForm.vue';
import FloatingContactButton from './Contact/FloatingContactButton.vue';
import { useAnchorId } from '@/composables/useAnchorId';

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
});

const anchorId = useAnchorId(toRef(props, 'data'));
</script>

<style lang="scss" scoped>
.contact-block {
  max-width: var(--main-width);
  margin-inline: auto;
  border-radius: 4.25rem;
  padding: 3rem 2rem;
  color: var(--mahogany);
}

.contact-intro {
  margin-bottom: 3rem;
  line-height: 1.6;

  :deep(svg) {
    width: 3rem;
    position: relative;
    top: 0.5em;
    margin-right: 0.5rem;
  }

  :deep(svg) path, :deep(svg) line, :deep(svg) polyline  {
    stroke-width: 0.3em;
    stroke: var(--mahogany);
  }

  :deep(p) {
    font-size: var(--text-xl);
    margin-bottom: 1rem;
    display: inline;
  }

  :deep(a) {
    color: var(--orange);
    font-size: var(--text-xl);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
